<template>
  <div>
    <!--顶部工具条-->
    <el-col :span="24">
      <el-form :inline="true">
        <el-form-item label="">
          <el-input
            style="width: 180px"
            v-model="filters.campaignName"
            placeholder="请输入关键字搜索"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-select
            style="width: 170px"
            v-model="filters.auditStatus"
            placeholder="请选择审核状态"
            clearable
          >
            <el-option
              v-for="item in isAuditOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select
            style="width: 170px"
            v-model="filters.executingStatus"
            placeholder="请选择发送状态"
            clearable
          >
            <el-option
              v-for="item in isSendOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item style="margin-left: 20px">
          <toolbar
            :buttonList="buttonList"
            @callFunction="callFunction"
          ></toolbar>
        </el-form-item>
      </el-form>
    </el-col>
    <!--列表-->
    <el-table
      :data="tableData"
      highlight-current-row
      v-loading="listLoading"
      style="width: 100%"
      border
      @current-change="selectCurrentRow"
      class="custom-padding-table"
    >
      <el-table-column
        prop="batchNo"
        label="批次编号"
        width="200"
        align="center"
        show-overflow-tooltip
      ></el-table-column>

      <el-table-column
        prop="campaignName"
        label="群发短信任务名称"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="content"
        label="短信内容"
        align="center"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="sendTime"
        label="发送时间"
        width="240"
        align="center"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="cityName"
        label="审核状态"
        align="center"
        show-overflow-tooltip
      >
        <template #default="scope">
          <el-tag type="info" v-if="scope.row.auditStatus == 1">未审核</el-tag>
          <el-tag type="success" v-if="scope.row.auditStatus == 2"
            >已审核通过</el-tag
          >
          <el-tag type="danger" v-if="scope.row.auditStatus == 3">拒绝</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="executingStatus"
        label="发送状态"
        align="center"
        show-overflow-tooltip
      >
        <template #default="scope">
          <el-tag type="info" v-if="scope.row.executingStatus == 0"
            >未执行</el-tag
          >
          <el-tag type="success" v-if="scope.row.executingStatus == 1"
            >已执行</el-tag
          >
          <el-tag type="danger" v-if="scope.row.executingStatus == 2"
            >执行中</el-tag
          >
          <el-tag type="info" v-if="scope.row.executingStatus == 3"
            >执行失败</el-tag
          >
        </template></el-table-column
      >
      <el-table-column
        prop="totalCount"
        label="号码个数"
        align="center"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="deliverRate"
        label="送达率"
        align="center"
        show-overflow-tooltip
      >
        <template #default="scope"> {{ scope.row.deliverRate }}% </template>
      </el-table-column>
      <el-table-column
        prop="clickRate"
        label="点击率"
        align="center"
        show-overflow-tooltip
      >
        <template #default="scope">
          {{ scope.row.clickRate }}%
        </template></el-table-column
      >
      <el-table-column
        prop="registerRate"
        label="注册率"
        align="center"
        show-overflow-tooltip
      >
        <template #default="scope">
          {{ scope.row.registerRate }}%
        </template></el-table-column
      >
      <el-table-column
        prop="createTime"
        label="创建日期"
        width="200"
        align="center"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column label="操作" width="" align="center">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="handleClick(scope.row)"
            >审核</el-button
          >
          <el-button
            type="text"
            size="small"
            @click="jumpSMSBulkTaskDetail(scope.row)"
            >查看明细</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!--底部工具条-->
    <el-col :span="24" class="pageBar">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pages.pageIndex"
        :page-sizes="pages.pageArr"
        :page-size="pages.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pages.dataCount"
      >
      </el-pagination>
    </el-col>

    <!--订单新增区域新增界面-->
    <el-dialog
      :title="editmark == true ? '编辑' : '新增'"
      :visible.sync="FormVisible"
      v-model="FormVisible"
      :close-on-click-modal="false"
    >
      <div style="display: flex">
        <div class="left" style="flex: 1">
          <el-form
            :model="Form"
            label-width="100px"
            ref="Form"
            style="max-width: 700px"
            :rules="FormRules"
          >
            <el-form-item label="群发对象：" prop="numberLibraryId">
              <el-select
                clearable
                v-model="Form.numberLibraryId"
                placeholder="请选择号码库"
              >
                <el-option
                  v-for="item in numberLibraryOptions"
                  :key="item.id"
                  :label="item.numberName"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="通知名称: " prop="campaignName">
              <el-input
                v-model="Form.campaignName"
                auto-complete="off"
                placeholder="请输入通知名称"
              ></el-input>
            </el-form-item>

            <el-form-item
              style="display: inline-block"
              label="模板分类:"
              prop="notificationTemplateId"
            >
              <el-select
                clearable
                v-model="Form.notificationTemplateId"
                placeholder="请选择模板"
                @change="templateChange"
              >
                <el-option
                  v-for="item in noticeTemplateOptions"
                  :key="item.id"
                  :label="item.templateTitle"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="模板名称：" prop="">
              <el-input
                v-model="templateName"
                auto-complete="off"
                placeholder="请输入"
                disabled
              ></el-input>
            </el-form-item>
            <el-form-item label="模板内容：" prop="">
              <el-input
                v-model="Form.content"
                auto-complete="off"
                placeholder="请输入"
                disabled
              ></el-input>
            </el-form-item>

            <el-form-item label="最大限额：" prop="batchMax">
              <el-input
                v-model="Form.batchMax"
                auto-complete="off"
                placeholder="请输入"
              ></el-input>
            </el-form-item>

            <el-form-item label="发送时间：" prop="sendType">
              <el-radio-group v-model="Form.sendType">
                <el-radio :label="0">立即发送</el-radio>
                <el-radio :label="1">定时发送</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="" prop="sendTime" v-if="Form.sendType == 1">
              <el-date-picker
                v-model="Form.sendTime"
                type="datetime"
                placeholder="选择日期时间"
                prop="sendTime"
              >
              </el-date-picker>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="FormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="FormSubmit"
          :loading="listLoading"
          >保存</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      title="审核"
      :visible.sync="AuditVisible"
      v-model="AuditVisible"
      :close-on-click-modal="false"
    >
      <div>
        <el-form
          :model="Form2"
          label-width="100px"
          ref="Form2"
          style="max-width: 700px"
          :rules="FormRules2"
        >
          <el-form-item label="审核状态" prop="auditStatus">
            <el-radio-group v-model="Form2.auditStatus">
              <el-radio :label="2">审核通过</el-radio>
              <el-radio :label="3">拒绝</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click.native="AuditVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="FormSubmit2"
          :loading="listLoading"
          >保存</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import util from "../../../util/date";
import {
  getSmsNotificationTaskListPageApi,
  addSmsNotificationTaskApi,
  editSmsNotificationTaskApi,
  getPhoneNumberListApi,
  getNoticeTemplateListPageApi,
  updateSmsNotificationTaskAuditStatusApi,
} from "../../api/api";
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import Qs from "qs";
export default {
  components: { Toolbar },
  data() {
    return {
      util: "",
      tableData: [],
      listLoading: false,
      //增删改查按钮
      buttonList: [],
      //顶部筛选条件
      filters: {
        campaignName: "",
        auditStatus: "",
        executingStatus: "",
      },

      //关于分页的obj
      pages: {
        pageSize: 20, //默认每页条数
        pageArr: [1, 20, 30, 40], //默认每页条数选择
        pageIndex: 1, //默认进入页
        dataCount: 20, //默认总页数
      },

      numberLibraryOptions: [],
      noticeTemplateOptions: [],
      templateName: "",

      FormVisible: false,
      Form: {
        numberLibraryId: "",
        campaignName: "",
        notificationTemplateId: "",
        content: "",
        batchMax: "",
        sendType: 0,
        sendTime: "",
      },
      Form2: {
        id: "",
        auditStatus: "",
      },
      isAuditOptions: [
        {
          value: 1,
          label: "未审核",
        },
        {
          value: 2,
          label: "已审核",
        },
        {
          value: 3,
          label: "已拒绝",
        },
      ],
      isSendOptions: [
        {
          value: 0,
          label: "平台未发送",
        },
        {
          value: 1,
          label: "平台已发送",
        },
        {
          value: 2,
          label: "执行中",
        },
      ],
      FormRules: {
        numberLibraryId: [
          { required: true, message: "请选择号码库", trigger: "blur" },
        ],
        campaignName: [
          { required: true, message: "请输入通知名称", trigger: "blur" },
        ],
        notificationTemplateId: [
          { required: true, message: "请选择短信模板", trigger: "blur" },
        ],
        batchMax: [
          { required: true, message: "请输入最大限额", trigger: "blur" },
        ],
        sendType: [
          { required: true, message: "请选择发送类型", trigger: "blur" },
        ],
        sendTime: [
          { required: true, message: "请选择发送时间", trigger: "blur" },
        ],
      },
      FormRules2: {
        auditStatus: [
          { required: true, message: "请选择审核状态", trigger: "blur" },
        ],
      },
      currentRow: "",
      editmark: false,
      AuditVisible: false,
    };
  },
  methods: {
    jumpSMSBulkTaskDetail(row) {
      console.log("11111");
      this.$router.push({
        path: "/SMSBulkTaskDetail",
        query: {
          id: row.id,
        },
      });
    },
    handleClick(row) {
      console.log("row", row);
      this.Form2.id = row.id;
      this.AuditVisible = true;
    },
    FormSubmit2() {
      this.$refs.Form2.validate((valid) => {
        console.log("valid", valid);
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.listLoading = true;
            let params = {
              ...this.Form2,
            };
            updateSmsNotificationTaskAuditStatusApi(params).then((res) => {
              if (res.data.success) {
                this.listLoading = false;
                this.$message({
                  message: res.data.message,
                  type: "success",
                });
                // this.$refs["Form2"].resetFields();
                this.AuditVisible = false;
                this.getList();
              } else {
                this.listLoading = false;
                this.$message({
                  message: res.data.message,
                  type: "error",
                });
              }
            });
          });
        }
      });
    },
    // 【新增】查询按钮调用的方法
    handleSearch() {
      this.pages.pageIndex = 1;
      this.getList();
    },
    getList() {
      var params = {
        ...this.filters,
        pageIndex: this.pages.pageIndex,
        pageSize: this.pages.pageSize,
      };
      getSmsNotificationTaskListPageApi(params).then((res) => {
        this.tableData = res.data.response.data;

        this.pages.dataCount = res.data.response.dataCount;
      });
    },

    selectCurrentRow(row) {
      this.currentRow = row;
    },

    async handleEdit() {
      if (!this.currentRow) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error",
        });
        return;
      }
      // 等待 DOM 渲染完成再调用 resetFields
      this.$nextTick(() => {
        if (this.$refs.Form) {
          this.$refs.Form.resetFields();
        }
      });
      this.editmark = true;
      // 深拷贝一下
      this.Form = {
        numberLibraryId: this.currentRow.numberLibraryId,
        campaignName: this.currentRow.campaignName,
        notificationTemplateId: this.currentRow.notificationTemplateId,
        content: this.currentRow.content,
        batchMax: this.currentRow.batchMax,
        sendType: this.currentRow.sendType,
        sendTime: this.currentRow.sendTime,
      };
      // 在选项列表中查找对应的对象
      const selectedOption = this.noticeTemplateOptions.find(
        (item) => item.id === this.currentRow.notificationTemplateId
      );
      if (selectedOption) {
        // 自动填充到你的变量中
        this.templateName = selectedOption.templateTitle;
      }
      this.FormVisible = true;
    },
    handleAdd() {
      // 等待 DOM 渲染完成再调用 resetFields
      this.$nextTick(() => {
        if (this.$refs.Form) {
          this.$refs.Form.resetFields();
        }
      });
      this.editmark = false;
      (this.Form = {
        numberLibraryId: "",
        campaignName: "",
        notificationTemplateId: "",
        content: "",
        batchMax: "",
        sendType: 0,
        sendTime: "",
      }),
        (this.templateName = "");
      this.FormVisible = true;
    },

    //提交新增表单
    FormSubmit() {
      this.$refs.Form.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.listLoading = true;
            const { sendTime, ...restForm } = this.Form;

            let params = {
              ...restForm,
            };
            if (this.Form.sendType == 1) {
              params.sendTime = this.formatCreateTime(sendTime);
            }
            console.log("params", params);

            if (this.editmark) {
              params.id = this.currentRow.id;
              editSmsNotificationTaskApi(params).then((res) => {
                if (res.data.success) {
                  this.listLoading = false;
                  this.$message({
                    message: res.data.message,
                    type: "success",
                  });
                  this.$refs["Form"].resetFields();
                  this.FormVisible = false;
                  this.getList();
                } else {
                  this.listLoading = false;
                  this.$message({
                    message: res.data.message,
                    type: "error",
                  });
                }
              });
            } else {
              addSmsNotificationTaskApi(params).then((res) => {
                if (res.data.success) {
                  this.listLoading = false;
                  this.$message({
                    message: res.data.message,
                    type: "success",
                  });
                  this.$refs["Form"].resetFields();
                  this.FormVisible = false;
                  this.handleSearch();
                } else {
                  this.listLoading = false;
                  this.$message({
                    message: res.data.message,
                    type: "error",
                  });
                }
              });
            }
          });
        }
      });
    },

    formatCreateTime: function (date) {
      return !date || date == ""
        ? ""
        : util.formatDate.format(new Date(date), "yyyy-MM-dd hh:mm:ss");
    },

    // apply改变this指向
    callFunction(item) {
      this[item.func].apply(this, item);
    },
    // 分页
    handleCurrentChange(val) {
      this.pages.pageIndex = val;
      this.getList();
    },
    handleSizeChange(val) {
      this.pages.pageSize = val;
      this.getList();
    },

    // 获取号码库列表
    getNumberLibraryList() {
      getPhoneNumberListApi().then((res) => {
        this.numberLibraryOptions = res.data.response.data;
      });
    },
    // 获取模板列表
    getNoticeTemplateList() {
      getNoticeTemplateListPageApi().then((res) => {
        this.noticeTemplateOptions = res.data.response.data;
      });
    },
    templateChange(val) {
      if (!val) {
        // 如果清空了选择，处理逻辑
        this.templateName = "";
        this.Form.content = "";
        return;
      }

      // 在选项列表中查找对应的对象
      const selectedOption = this.noticeTemplateOptions.find(
        (item) => item.id === val
      );
      if (selectedOption) {
        // 自动填充到你的变量中
        this.templateName = selectedOption.templateTitle;
        // 如果有模板内容，也可以顺便填进去 (假设接口返回了 content 字段)
        this.Form.content = selectedOption.templateContent;
      }
    },
  },
  mounted() {
    this.getList();
    this.getNumberLibraryList();
    this.getNoticeTemplateList();
    this.util = util;
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>
<style lang="stylus" scoped>
.rolesTop {
  width: 100%;
  display: flex;
}

.rolesInp {
  width: 300px;
  margin-right: 20px;
}

.pageBar {
  margin-top: 15px;
}

/* 👇👇👇 新增的样式开始 👇👇👇 */
.custom-padding-table {
  ::v-deep .el-table__cell {
    /* 上下内边距，根据需要调整数值，默认通常是 8px 或 10px */
    padding-top: 16px;
    padding-bottom: 16px;
  }

  /* 如果上面的写法在某些构建环境下不生效，可以尝试加 !important 强制覆盖 */
  ::v-deep td.el-table__cell {
    padding-top: 16px !important;
    padding-bottom: 16px !important;
  }
}

/* 👆👆👆 新增的样式结束 👆👆👆 */
</style>
